"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const apiHelpers_1 = require("./apiHelpers");
class TelemetryUploader {
    constructor({ apiKey, apiEndpoint = undefined, timeout, clientVersion, }) {
        this.apiKey = apiKey;
        this.apiEndpoint = apiEndpoint || "https://api.prefab.cloud/api/v1";
        this.timeout = timeout || apiHelpers_1.DEFAULT_TIMEOUT;
        this.clientVersion = clientVersion;
    }
    clearAbortTimeout() {
        clearTimeout(this.abortTimeoutId);
    }
    static postUrl(root) {
        return `${root}/telemetry`;
    }
    postToEndpoint(options, resolve, reject) {
        const controller = new AbortController();
        const signal = controller === null || controller === void 0 ? void 0 : controller.signal;
        const url = TelemetryUploader.postUrl(this.apiEndpoint);
        fetch(url, Object.assign({ signal }, options))
            .then((response) => {
            this.clearAbortTimeout();
            if (response.ok) {
                return response.json();
            }
            // eslint-disable-next-line no-console
            console.warn(`Prefab warning: Error uploading telemetry ${response.status} ${response.statusText}`);
            return response.status;
        })
            .then((response) => {
            resolve(response);
        })
            .catch((error) => {
            this.clearAbortTimeout();
            reject(error);
        });
        this.abortTimeoutId = setTimeout(() => {
            controller.abort();
        }, this.timeout);
    }
    post(data) {
        const options = {
            method: "POST",
            headers: Object.assign(Object.assign({}, (0, apiHelpers_1.headers)(this.apiKey, this.clientVersion)), { "Content-Type": "application/json", Accept: "application/json" }),
            body: JSON.stringify(data),
            keepalive: true, // needed for flushing when the window is closed
        };
        const promise = new Promise((resolve, reject) => {
            this.postToEndpoint(options, resolve, reject);
        });
        return promise;
    }
}
exports.default = TelemetryUploader;
